<template>
  <div class="page-module">
    <app-header v-bind="headerConfig"></app-header>

    <div class="main">
      <h3 class="stimulate-note" v-html="stimulateNote" :style="{lineHeight: + stimulateHeight + 'px'}"></h3>

      <!--<creation-type @modal="cutModal"></creation-type>-->

      <ul class="creation-types" ref="creationTypes">
        <li v-for="(list, styleIndex) in datas.creationType.baseTypes" class="type-list">
          <div class="slogan">
            <div class="type-title">
              <span>{{list.title}}</span>
              <i class="explain" v-text="list.explain"></i>
            </div>
            <p class="hint-note" v-html="list.intro"></p>
          </div>
          <ul class="clearfix">
            <li v-for="(type, typeIndex) in list.btnType" class="type-option"
                @click="createStory(styleIndex, typeIndex)">
              <p class="note" v-text="type"></p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <create-story-win v-if="moduleState.createStoryWin"></create-story-win>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header'
  import CreationType from '../components/creation_type'
  import orgModal from './create_story_win'
  import {ComponentName, Methods} from '../const/common'

  export default {
    name: 'creation_type',
    store,
    components: {
      'app-header': AppHeader,
      'creation-type': CreationType,
      'create-story-win': orgModal
    },
    computed: mapState(['parrent', 'datas', 'moduleState']),
    data() {
      return {
        headerConfig: {
          title: '开始创作',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.creation.backNote,
          backPage: store.state.nextPageHeaderConf.creation.backPage,
          closeModule: ComponentName.CREATEION_TYPE
        },
        stimulateNote: '不要放走灵感和热情',
        modalConfig: {
          type: 'crateStory',
          isShow: false
        },
        openType: '',
        btnTypeArr: store.state.datas.creationType.btnType,
        baseTypeArr: store.state.datas.creationType.baseTypes,
        stimulateHeight: 0,
      }
    },
    methods: {
      cutModal(b, type) {
        this.$data.openType = type;
        this.$data.modalConfig.isShow = b;
      },
      createStory(useModal, style) {
        this.parrent.style = style;
        this.parrent.createType = useModal;
        this.parrent.useModal = useModal === 0 ? true : false;
        Methods.cutComponent([ComponentName.CREATE_STORY_WIN], true);
        Methods.checkChapterHash(5);
      }
    },
    mounted() {
      this.$nextTick(function () {
        this.stimulateHeight = this.$refs.creationTypes.offsetTop + .18 * (document.documentElement.clientWidth / 3.6);
      });
    }
  }
</script>

<style scoped>
  @import "../style/css/creation_type.css";
</style>



// WEBPACK FOOTER //
// src/components/creation_type_main.vue